/* ============================================
   PROLIFIC™ Trimmer — Landing Page Scripts
   The Rich Barber®
   ============================================ */

(function () {
  'use strict';

  // --- Mobile Menu Toggle ---
  var burger = document.getElementById('nav-burger');
  var mobileMenu = document.getElementById('mobile-menu');

  if (burger && mobileMenu) {
    burger.addEventListener('click', function () {
      burger.classList.toggle('active');
      mobileMenu.classList.toggle('active');
    });

    // Close on link click
    mobileMenu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        burger.classList.remove('active');
        mobileMenu.classList.remove('active');
      });
    });
  }

  // --- Scroll Animations (IntersectionObserver) ---
  var animatedElements = document.querySelectorAll('[data-animate]');

  if ('IntersectionObserver' in window && animatedElements.length) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var el = entry.target;
            var delay = parseInt(el.getAttribute('data-delay') || '0', 10);
            if (delay > 0) {
              setTimeout(function () {
                el.classList.add('visible');
              }, delay);
            } else {
              el.classList.add('visible');
            }
            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -50px 0px' }
    );

    animatedElements.forEach(function (el) {
      observer.observe(el);
    });
  } else {
    // Fallback: show everything
    animatedElements.forEach(function (el) {
      el.classList.add('visible');
    });
  }

  // --- Animated Stat Counters ---
  var statValues = document.querySelectorAll('[data-count]');
  var statsAnimated = false;

  function animateCounters() {
    if (statsAnimated) return;
    statsAnimated = true;

    statValues.forEach(function (el) {
      var target = parseInt(el.getAttribute('data-count'), 10);
      var suffix = el.getAttribute('data-suffix') || '';
      var duration = 1500;
      var start = 0;
      var startTime = null;

      function easeOutCubic(t) {
        return 1 - Math.pow(1 - t, 3);
      }

      function step(timestamp) {
        if (!startTime) startTime = timestamp;
        var progress = Math.min((timestamp - startTime) / duration, 1);
        var easedProgress = easeOutCubic(progress);
        var current = Math.round(start + (target - start) * easedProgress);

        if (target >= 1000) {
          el.textContent = current.toLocaleString() + suffix;
        } else {
          el.textContent = current + suffix;
        }

        if (progress < 1) {
          requestAnimationFrame(step);
        }
      }

      requestAnimationFrame(step);
    });
  }

  // Trigger counter animation when stats strip is visible
  var statsStrip = document.querySelector('.stats-strip');
  if (statsStrip && 'IntersectionObserver' in window) {
    var statsObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animateCounters();
            statsObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.3 }
    );
    statsObserver.observe(statsStrip);
  }

  // --- Color Swatch Toggle (Hero) ---
  var heroSwatches = document.querySelectorAll('.hero__swatch'); 
  var heroProduct = document.querySelector('.hero__product');

  heroSwatches.forEach(function (swatch) {
    swatch.addEventListener('click', function () {
      heroSwatches.forEach(function (s) { s.classList.remove('active'); });
      swatch.classList.add('active');

      // Swap hero image based on selected color
      // Change the code to maintain shopify rules
      if (swatch.classList.contains('hero__swatch--blkgry')) {
        heroProduct.src = window.prolificImages.blkGry;
        heroProduct.alt = 'PROLIFIC™ Trimmer — Side view';
      } else {
        heroProduct.src = window.prolificImages.bob;
        heroProduct.alt = 'PROLIFIC™ Trimmer — Front View';
      }
    });
  });

  // --- Color Swatch Toggle (Offer) ---
  var offerColorOptions = document.querySelectorAll('.offer__color-opt'); 
  var offerProduct = document.querySelector('.offer__product-img');
  var allOfferSwatches = document.querySelectorAll('.offer__swatch');

  offerColorOptions.forEach(function (optionWrapper) {
    optionWrapper.addEventListener('click', function () {
      var swatch = optionWrapper.querySelector('.offer__swatch');
      allOfferSwatches.forEach(function (s) { s.classList.remove('active'); });
      swatch.classList.add('active');

      // Swap Offer image based on selected color
      if (swatch.classList.contains('offer__swatch--blkgry')) {
        offerProduct.src = window.prolificImages.blkGry;
        offerProduct.alt = 'PROLIFIC™ Trimmer — Side view';
      } else {
        offerProduct.src = window.prolificImages.bob;
        offerProduct.alt = 'PROLIFIC™ Trimmer — Front View';
      }
    });
  });

  // --- Smooth scroll for anchor links ---
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      var targetId = this.getAttribute('href');
      if (targetId === '#') return;
      var target = document.querySelector(targetId);
      if (target) {
        e.preventDefault();
        var offset = 80;
        var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    });
  });

})();

// Safari browser form add-to-cart problem(fix)
document.addEventListener('DOMContentLoaded', function() {
  var externalButtons = document.querySelectorAll('.js-safari-submit');
  var bundleForm = document.getElementById('prolific-bundle-form');
  var colorDropdown = document.getElementById('prolific-color');
  var errorMsg = document.getElementById('prolific-error-msg');

  externalButtons.forEach(function(button) {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      // 1. Check if the user forgot to select a color
      if (!colorDropdown.value) {
        colorDropdown.classList.add('error-border');
        errorMsg.style.display = 'block';
        colorDropdown.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else {
        // 2. If a color is selected, submit the Shopify form safely!
        bundleForm.submit();
      }
    });
  });
});